<template>
    <div class="my-5">
        <b-card no-body>
            <b-tabs pills card
                active-nav-item-class="font-weight-bold text-uppercase">
                <b-tab :active="tab==1">
                    <template #title>
                        <i class="mr-2 fas fa-user"></i>Información Cuenta
                    </template>
                    <b-card>
                        <cuenta/>                        
                    </b-card>
                </b-tab>                    
                <b-tab :active="tab==2">
                    <template #title>
                        <i class="mr-2 fas fa-credit-card"></i><span class="nav-item"> Mis Reservas </span>
                    </template>
                    <b-card>
                        <!-- <reservas/> -->
                    </b-card>
                </b-tab>
                <b-tab :active="tab==3">
                    <template #title>
                        <i class="mr-2 fas fa-key"></i>Cambio Contraseña                                                                    
                    </template>
                    <b-card>
                        <cambio/>                        
                    </b-card>
                </b-tab>
                    <b-tab :active="tab==4">
                    <template #title>
                        <i class="mr-2 fas fa-bell"></i>Notificaciones                                                                    
                    </template>
                    <b-card>
                        <b-card-text>
                            <h2> No hay Notificaciones</h2>                    
                        </b-card-text>
                    </b-card>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>        
</template>
<script>

import cuenta from '@/components/cuenta.vue'
import cambio from '@/components/cambio-password.vue'
// import reservas from '@/views/Reservas.vue'

export default {
    name: 'info-personal',
    props: {
        tab: Number,
    },
    components: {
        cuenta,
        cambio,
        //reservas,
        
    },
    data() {
        return {

        }
    },   
    created() {
        if (!this.$store.state.auth.token) {
            this.$router.push('/');
        }
        //console.log(this.name + ' *created',this.$store.state.auth);
    }
}
</script>